// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "experiment_assignment".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "experiment_assignment" table (1:1 with a DB row, on the wire). */
export const experimentAssignmentAtomSchema = z.object({
    id: z.string(),
    experimentId: z.string(),
    organizationId: z.string(),
    variant: z.string(),
    assignedAt: z.string().datetime(),
});
//# sourceMappingURL=experimentAssignment.js.map